import React from 'react';
import { motion } from 'framer-motion';
interface CTAButtonProps {
  text?: string;
  subtext?: string;
  href?: string;
  className?: string;
}
export function CTAButton({
  text = '¡QUIERO VOLVER A DORMIR HOY!',
  subtext = 'Acceso inmediato después del pago. Disponible 24/7.',
  href,
  className = ''
}: CTAButtonProps) {
  return <div className={`flex flex-col items-center w-full ${className}`} data-id="element-183">
      <motion.button whileHover={{
      scale: 1.02
    }} whileTap={{
      scale: 0.98
    }} onClick={() => {
      if (href) {
        window.open(href, '_blank', 'noopener,noreferrer');
      } else {
        document.getElementById('pricing')?.scrollIntoView({
          behavior: 'smooth'
        });
      }
    }} className="w-full max-w-md bg-gold-gradient text-navy-900 font-bold text-lg md:text-xl py-5 px-8 rounded-full shadow-[0_0_20px_rgba(212,168,83,0.3)] hover:shadow-[0_0_30px_rgba(212,168,83,0.5)] transition-shadow duration-300 relative overflow-hidden group cursor-pointer" data-id="element-184">
        <div className="absolute inset-0 bg-white/20 translate-y-full group-hover:translate-y-0 transition-transform duration-300 ease-out" data-id="element-185" />
        <span className="relative z-10" data-id="element-186">{text}</span>
      </motion.button>
      {subtext && <p className="mt-4 text-sm text-muted text-center flex items-center gap-2" data-id="element-187">
          <span className="w-2 h-2 rounded-full bg-green-500 animate-pulse" data-id="element-188" />
          {subtext}
        </p>}
    </div>;
}